// Metadata
export interface Metadata {
  key: string;
  value: string;
}

// Organization
export interface Organization {
  id: string;
  publicKey: string;
  name: string;
  alias: string;
  picture: string;
  email: string;
  phone: string;
  description: string;
  collaborators: string[];
  metadata: Metadata[];
}

export default class OrganizationClass {
  id = ''
  publicKey = ''
  name = ''
  alias = ''
  picture = ''
  email = ''
  phone = ''
  description = ''
  collaborators: string[] = []
  metadata: Metadata[] = []
}
